import { RequirementParameterResponse } from "lib-klab-sdks";
import { RequirementParameter } from "../../../domain/models/requirement/requirement-parameter.model";

export function mapRequirementParameter(source: RequirementParameterResponse): RequirementParameter {
  const { requirementParameterId, ...fields } = source;
  return { id: requirementParameterId, ...fields };
}
